const PHASES = new Set(['first', 'close', 'due']);

export const PHASE_LABELS = {
  first: 'Due soon',
  close: 'Soon',
  due: 'Due',
};

export function isHttpHref(href) {
  if (typeof href !== 'string' || !href.trim()) return false;
  try {
    const parsed = new URL(href);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (_) {
    return false;
  }
}

export function isUnreadItem(item) {
  if (!item || !PHASES.has(item.phase)) return false;
  return item.phase !== item.acknowledgedPhase;
}

export function isSeenItem(item) {
  return Boolean(item) && PHASES.has(item.phase) && item.phase === item.acknowledgedPhase;
}

function byUpdatedAtDesc(a, b) {
  return String(b.updatedAt || '').localeCompare(String(a.updatedAt || ''));
}

/**
 * Split inbox docs into unread rows (badge) and seen rows (still listed).
 * Dismiss acknowledges the current beat; the row stays until the logbook deletes it.
 */
export function classifyInboxItems(docs) {
  const unread = [];
  const seen = [];
  const list = Array.isArray(docs) ? docs : [];

  for (const item of list) {
    if (!item || !item.sourceKey) continue;
    if (isUnreadItem(item)) unread.push(item);
    else if (isSeenItem(item)) seen.push(item);
  }

  unread.sort(byUpdatedAtDesc);
  seen.sort(byUpdatedAtDesc);
  return { unread, seen, badgeCount: unread.length };
}
